module.exports = function(exec){
  try {
    exec();
    return false;
  } catch(e){
    return true;
  }
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/~/core-js/library/modules/$.throws.js
 ** module id = 187
 ** module chunks = 0
 **/